import { Rect } from '@/types';
import { degreeToRad } from '@/utils/math/degreeToRad';
import { rotatePoint } from '@/utils/math/rotatePoint';

export function getRotatedRect(rotationInDeg: number, rect: Rect): Rect {
  const rot = degreeToRad(rotationInDeg);
  const rotationCenter = {
    x: (rect.width + 2 * rect.x) / 2,
    y: (rect.height + 2 * rect.y) / 2,
  };

  const rotatedLeftTopCorner = rotatePoint(rect.x, rect.y, rot, rotationCenter.x, rotationCenter.y);
  const rotatedLeftBottomCorner = rotatePoint(
    rect.x,
    rect.height + rect.y,
    rot,
    rotationCenter.x,
    rotationCenter.y
  );
  const rotatedRightTopCorner = rotatePoint(
    rect.width + rect.x,
    rect.y,
    rot,
    rotationCenter.x,
    rotationCenter.y
  );
  const rotatedRightBottomCorner = rotatePoint(
    rect.width + rect.x,
    rect.height + rect.y,
    rot,
    rotationCenter.x,
    rotationCenter.y
  );

  const minX = Math.min(
    rotatedLeftTopCorner.x,
    rotatedLeftBottomCorner.x,
    rotatedRightTopCorner.x,
    rotatedRightBottomCorner.x
  );
  const maxX = Math.max(
    rotatedLeftTopCorner.x,
    rotatedLeftBottomCorner.x,
    rotatedRightTopCorner.x,
    rotatedRightBottomCorner.x
  );
  const minY = Math.min(
    rotatedLeftTopCorner.y,
    rotatedLeftBottomCorner.y,
    rotatedRightTopCorner.y,
    rotatedRightBottomCorner.y
  );
  const maxY = Math.max(
    rotatedLeftTopCorner.y,
    rotatedLeftBottomCorner.y,
    rotatedRightTopCorner.y,
    rotatedRightBottomCorner.y
  );

  const width = maxX - minX;
  const height = maxY - minY;
  return { width, height, x: minX, y: minY };
}
